<template>
  <div class="form-section mb-0">
    <div class="row">

      <div class="col-md-6">
        <div class="form-group">
          <label>Empresa *</label>
          <SearchableDropdown
            placeholder="Elegir empresa"
            :options="companies"
            :oldValue="form.companyId"
            @selected="onCompanySelected($event)"
            :show-error="v.companyId.$error && !v.companyId.required"
          />
          <FormError
            v-if="v.companyId.$error && !v.companyId.required"
            message="Empresa es requerida"
          />
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-group">
          <label>Sede</label>
          <SearchableDropdown
            placeholder="Elegir sede"
            :options="workSites"
            :oldValue="form.workSiteId"
            @selected="form.workSiteId = $event"
          />
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-group">
          <label>Área *</label>
          <SearchableDropdown
            placeholder="Elegir área"
            :options="areas"
            :oldValue="form.areaId"
            @selected="form.areaId = $event"
            :show-error="v.areaId.$error && !v.areaId.required"
          />
          <FormError
            v-if="v.areaId.$error && !v.areaId.required"
            message="Área es requerida"
          />
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-group">
          <label>Cargo *</label>
          <SearchableDropdown
            placeholder="Elegir cargo"
            :options="positions"
            :oldValue="form.positionId"
            @selected="form.positionId = $event"
            :show-error="v.positionId.$error && !v.positionId.required"
          />
          <FormError
            v-if="v.positionId.$error && !v.positionId.required"
            message="Cargo es requerido"
          />
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-group">
          <label>Canal</label>
          <SearchableDropdown
            placeholder="Elegir canal"
            :options="channels"
            :oldValue="form.channelId"
            @selected="form.channelId = $event"
          />
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-group">
          <label>Línea de gasto</label>
          <SearchableDropdown
            placeholder="Elegir línea de gasto"
            :options="expenseLines"
            :oldValue="form.expenseLineId"
            @selected="form.expenseLineId = $event"
          />
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-group">
          <label>Jefe directo</label>
          <SearchableDropdown
            placeholder="Elegir jefe directo"
            :options="employees"
            :oldValue="form.directManagerId"
            @selected="form.directManagerId = $event"
          />
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-group">
          <label>Horario de trabajo</label>
          <SearchableDropdown
            placeholder="Elegir horario"
            :options="schedules"
            :oldValue="form.scheduleId"
            @selected="form.scheduleId = $event"
          />
          <p v-if="selectedSchedule" class="text-muted small mt-1 mb-0">
            {{ selectedScheduleSummary }}
          </p>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { FormError, SearchableDropdown } from 'wize-admin'

const DAY_SHORT = { 1:'Lun', 2:'Mar', 3:'Mié', 4:'Jue', 5:'Vie', 6:'Sáb', 7:'Dom' }

export default {
  components: { FormError, SearchableDropdown },
  props: {
    form:      { type: Object, required: true },
    v:         { type: Object, required: true },
    companies: { type: Array,  default: () => [] },
    workSites: { type: Array,  default: () => [] },
    areas:     { type: Array,  default: () => [] },
    positions: { type: Array,  default: () => [] },
    employees:    { type: Array,  default: () => [] },
    schedules:    { type: Array,  default: () => [] },
    channels:     { type: Array,  default: () => [] },
    expenseLines: { type: Array,  default: () => [] },
  },
  computed: {
    selectedSchedule() {
      return this.schedules.find(s => s.key === this.form.scheduleId) || null
    },
    selectedScheduleSummary() {
      const s = this.selectedSchedule
      if (!s) return ''
      const days = (s.workDaysList || []).map(d => DAY_SHORT[d] || d).join('-')
      return `${days} ${s.entryTime || ''}-${s.exitTime || ''}, ${s.effectiveHours}h efectivas`
    },
  },
  emits: ['company-changed'],
  methods: {
    onCompanySelected(companyId) {
      this.form.companyId  = companyId
      this.form.workSiteId = null
      this.$emit('company-changed', companyId)
    },
  },
}
</script>

<style lang="stylus" scoped></style>
